import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    flex
    flex-col
    p-0
    rounded-2xl
  `
)

export const imgStyles = cva(
  `
    flex
    justify-center
    p-4
    rounded-t-2xl
  `
)

export const bodyStyles = cva(
  `
    flex
    flex-col
    p-6
    gap-2
  `
)
